import create from "zustand";
import { devtools, persist } from "zustand/middleware";
import {
  KeplrWalletConnectorState,
  KeplrSignerWalletConnectorActions,
  initialKeplrWalletConnectorState,
} from "../walletConnectorInterfaces";

export const useKeplrWalletConnector = create<
  KeplrWalletConnectorState & KeplrSignerWalletConnectorActions
>()(
  devtools(
    persist(
      (set) => ({
        ...initialKeplrWalletConnectorState,
        catchKeplrWalletConnectError: (error: any) => {
          set((state) => ({
            ...state,
            error: error,
          }));
        },
        keplrConnectWallet: () => {
          set((state) => ({
            ...state,
            isKeplrConnecting: true,
            isKeplrConnected: false,
            connectedKeplrWalletAddress: "",
            keplrChainId: "0",
            error: "",
            CosmWasmClient: undefined,
          }));
        },
        keplrWalletConnected: (
          keplrWalletAddresses: any,
          keplrChainId: string,
          keplrWalletBalance: string,
          CosmWasmClient: any
        ) => {
          set((state) => ({
            ...state,
            isKeplrConnected: true,
            isKeplrConnecting: false,
            keplrWalletAddresses: keplrWalletAddresses,
            connectedKeplrWalletAddress: keplrWalletAddresses.shift().address,
            keplrWalletBalance: keplrWalletBalance,
            keplrChainId: keplrChainId,
            error: "",
            CosmWasmClient: CosmWasmClient,
          }));
        },
        resetKeplrWalletConnector: () => {
          set(() => ({
            ...initialKeplrWalletConnectorState,
          }));
        },
      }),
      {
        name: "keplrWalletConnector",
        getStorage: () => sessionStorage,
        partialize: (state) => ({
          isKeplrConnected: state.isKeplrConnected,
          connectedKeplrWalletAddress: state.connectedKeplrWalletAddress,
          keplrWalletAddresses: state.keplrWalletAddresses,
          keplrChainId: state.keplrChainId,
        }),
      }
    )
  )
);
